module.exports = __webpack_public_path__ + "static/media/buzka-czerwona.38523005.svg";